import { DataTableColumn, getCellLeftPosition } from '@shared/ui/data-table';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';
import clsx from 'clsx';

interface DataTableRowProps<T extends { id?: string }> {
  row: T;
  rowIndex: number;
  columns: DataTableColumn<T>[];
  gridTemplateColumns: string;
  isLastRow: boolean;
  lastElementRef: (node: HTMLDivElement) => void;
  isSelected: boolean;
  selectedClassName?: string;
}

export const DataTableRow = <T extends { id?: string }>({
  row,
  rowIndex,
  columns,
  gridTemplateColumns,
  isLastRow,
  lastElementRef,
  isSelected,
  selectedClassName,
}: DataTableRowProps<T>) => {
  return (
    <div
      className={clsx(stylex.props(styles.row).className, isSelected && selectedClassName)}
      style={{ gridTemplateColumns }}
      ref={isLastRow ? lastElementRef : null}
    >
      {columns.map((column, columnIndex) => (
        <div
          key={columnIndex}
          className={clsx(
            stylex.props(column.cellClassName ? styles.rowItemBase : styles.rowItem).className,
            column.cellClassName,
            column.fixed && stylex.props(styles.rowFixed).className
          )}
          style={{ left: getCellLeftPosition(columns, column) }}
        >
          {column.renderCell ? column.renderCell(row, rowIndex) : <span>{String(row[column.field] || '')}</span>}
        </div>
      ))}
    </div>
  );
};
